document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-variant-selector').forEach(function (selector) {
    const productId = selector.dataset.productId;
    const card = selector.closest('.card-wrapper');
    const mediaEl = card.querySelector(`[data-card-image="${productId}"]`);
    const priceEl = card.querySelector(`[data-card-price="${productId}"]`);
    const variantInput = selector.querySelector('.product-variant-id');
    const showStrikeoutEnabled = selector.dataset.showStrikeout === 'true';

    const productJson = document.querySelector(`#ProductJson-${productId}`);
    if (!productJson) return;
    const variants = JSON.parse(productJson.textContent).variants;

    const strikeoutJson = document.querySelector(`#StrikeoutJson-${productId}`);
    const strikeoutMap = strikeoutJson ? JSON.parse(strikeoutJson.textContent) : {};

    function getSelectedOptions() {
      return Array.from(selector.querySelectorAll('.card-option-group')).map(group => {
        return group.querySelector('input[type="radio"]:checked')?.value;
      });
    }

    function findVariant(selectedOptions) {
      return variants.find(v =>
        selectedOptions.every((val, i) => v[`option${i + 1}`] === val)
      );
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;

      const price = variant.price;
      const compareAt = variant.compare_at_price;
      const strikeoutValue = strikeoutMap[variant.id];

      let wasPrice;
      let nowPrice;

      if (showStrikeoutEnabled) {
        wasPrice = compareAt ? compareAt : price;
        nowPrice = strikeoutValue || price;
      } else {
        wasPrice = compareAt && compareAt > price ? compareAt : null;
        nowPrice = price;
      }

      if (wasPrice) {
        priceEl.innerHTML = `
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__sale flex-column justify-right">
                <span class="price-item price-item--regular"><s>${formatMoney(wasPrice)}</s></span>
                <span class="price-item price-item--sale price-item--last">${formatMoney(nowPrice)}</span>
              </div>
            </div>
          </div>`;
      } else {
        priceEl.innerHTML = `
          <div class="price">
            <div class="price__container">
              <div class="price__regular">
                <span class="price-item price-item--regular">${formatMoney(nowPrice)}</span>
              </div>
            </div>
          </div>`;
      }
    }

    function updateImage(variant) {
      if (!mediaEl || !variant.featured_image) return;
      const variantImg = mediaEl.querySelector(`[data-variant-image="${variant.id}"]`);
      if (variantImg) {
        mediaEl.querySelectorAll('img').forEach(img => img.style.display = 'none');
        variantImg.style.display = 'block';
      }
    }

    selector.addEventListener('change', function (e) {
      const input = e.target;
      if (!input.classList.contains('variant-radio')) return;

      const group = input.closest('.card-option-group');
      group.querySelectorAll('.variant-button-label').forEach(l => l.classList.remove('is-selected'));
      input.closest('.variant-button-label').classList.add('is-selected');

      const selected = getSelectedOptions();
      const variant = findVariant(selected);

      if (variant) {
        variantInput.value = variant.id;
        updatePrice(variant);
        updateImage(variant);
      }
    });
  });
});

$(document).ready(function () {
  $(".quantity__button").on("click", function (event) {
    event.preventDefault();

    var button = $(event.currentTarget);
    var quantityWrapper = button.closest('.quantity-wrapper');
    if (!quantityWrapper.length) return;

    var quantityInput = quantityWrapper.find('.quantity-input');
    if (!quantityInput.length) return;

    var currentQty = parseInt(quantityInput.val(), 10) || 1;
    var newQty = currentQty;

    if (button.hasClass('plus')) {
      newQty = currentQty + 1;
    } else if (button.hasClass('minus') && currentQty > 1) {
      newQty = currentQty - 1;
    }

    if (newQty < 1) newQty = 1;

    quantityInput.val(newQty.toString());

    var minusButton = quantityWrapper.find('.quantity__button.minus');
    if (newQty === 1) {
      minusButton.attr("disabled", "disabled");
    } else {
      minusButton.removeAttr("disabled");
    }
  });
});

(function () {
  const QUIZ_PARAM = 'okendo_quiz_response_id=';
  const QUIZ_SELECTOR = '[data-oke-quiz], oke-quiz, [class*="oke-quiz"], [id*="oke-quiz"], [class*="okeQuiz"]';
  const KLAVIYO_FORM_ID = 'Upszcu';
  const root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');

  let klaviyoOpened = false;
  let bypass = false;

  function quizActive() {
    return location.href.includes(QUIZ_PARAM) || !!document.querySelector(QUIZ_SELECTOR);
  }

  function triggerKlaviyoPopup() {
    if (klaviyoOpened || !location.href.includes(QUIZ_PARAM)) return;
    klaviyoOpened = true;
    window._klOnsite = window._klOnsite || [];
    setTimeout(() => window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]), 1000);
  }

  async function openCart() {
    if (typeof window.refreshDrawer === 'function') {
      const cart = await window.refreshDrawer();
      if (cart && typeof window.syncMilestoneRewards === 'function') await window.syncMilestoneRewards(cart);
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (_) {}
    }
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  function isCartPage(url) {
    return /\/cart\/?$/.test(url.pathname);
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?\/?$/.test(url.pathname);
  }

  function isDiscountToCart(url) {
    if (!/\/discount\//.test(url.pathname)) return false;
    const redirect = url.searchParams.get('redirect') || '';
    return /\/cart\/?$/.test(redirect.split('?')[0]);
  }

  function resolveCartAction(url, formData) {
    if (url.origin !== location.origin || !quizActive()) return null;

    if (isCartAdd(url)) {
      if (formData) {
        return () => fetch(`${root}cart/add.js?ts=${Date.now()}`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        }).then(r => {
          if (!r.ok) throw new Error('add failed');
        });
      }
      return () => fetch(url.href, { credentials: 'same-origin' });
    }

    if (isDiscountToCart(url)) {
      const discountUrl = new URL(url.href);
      discountUrl.searchParams.delete('redirect');
      return () => fetch(discountUrl.href, { credentials: 'same-origin' });
    }

    if (isCartPage(url)) return () => Promise.resolve();

    return null;
  }

  function handle(url, formData, event) {
    if (bypass || event.defaultPrevented) return;
    const action = resolveCartAction(url, formData);
    if (!action) return;
    event.preventDefault();
    action()
      .then(openCart)
      .catch(() => {
        bypass = true;
        location.href = url.href;
      });
  }

  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (e) {
      if (!e.cancelable) return;
      handle(new URL(e.destination.url), e.formData, e);
    });
  } else {
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (form.matches('form[data-type="quick-add-form"], form[data-type="add-to-cart-form"]')) return;
      const formData = form.method.toLowerCase() === 'post' ? new FormData(form, e.submitter || undefined) : null;
      handle(new URL(form.action, location.href), formData, e);
    });

    document.addEventListener('click', function (e) {
      const link = e.target.closest && e.target.closest('a[href]');
      if (!link || link.target === '_blank') return;
      handle(new URL(link.href, location.href), null, e);
    });
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      setTimeout(triggerKlaviyoPopup, 500);
      return result;
    };
  });

  window.addEventListener('popstate', triggerKlaviyoPopup);
  window.addEventListener('pageshow', function () {
    bypass = false;
  });

  triggerKlaviyoPopup();
})();